import CommentaireComponentModal from './commentaire.component.modal.controller';
import html from './commentaire.component.modal.html';

export default {
	bindings: {
		modalInstance: '<',
		resolve: '<'
	},
	template: html,
	controller: CommentaireComponentModal
};
